import $ from "jquery";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
window.bootstrap = bootstrap;

// Init plugins
import { slick_init } from './scripts/slick.js';
import { matchheight } from './scripts/matchheightplugin.js';
import { animejs } from './scripts/anime.js';
import { lity_init } from './scripts/lityplugin.js';
import { simpleparallax } from './scripts/simpleparallax.js';

// Scripts
import { site_is_loaded } from './scripts/site_is_loaded.js';
import { footer_down } from './scripts/footer_down.js';
import { mobilemenu } from './scripts/mobilemenu.js';
import { sticky_header } from './scripts/sticky_header.js';
import { banner } from './scripts/banner.js';
// import { loadmoreposts } from './scripts/loadmoreposts.js';

lity_init();
simpleparallax();

document.addEventListener('DOMContentLoaded', function() {
	var popoverTriggerList = [].slice.call(document.querySelectorAll('.btn-popover'));
	var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus'
		});
	});
});

document.addEventListener('click', function(event) {
	var popoverList = bootstrap.Popover.getInstance(document.querySelector('.popover-dismiss'));

	if (popoverList && !event.target.closest('.popover') && !event.target.closest('[data-toggle="popover"]')) {
		popoverList.hide();
	}
});

$( document ).ready(function() {
	mobilemenu();
	slick_init();
	banner();
	// loadmoreposts();	
});

$(window).on('load', function() {
	matchheight();
	footer_down();
	animejs();
	sticky_header();
	site_is_loaded();
});

